export const SET_MENTION_DATA = "SET_MENTION_DATA";
export const SET_COLUMNS = "SET_COLUMNS";
export const SET_NINJA_DL_MENTIONS = "SET_NINJA_DL_MENTIONS";
